/** Rangos de fecha compartidos (Pipeline Fríos / Tareas). */

export function startOfDay(ref) {
  const d = new Date(ref);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function endOfDay(ref) {
  const d = new Date(ref);
  d.setHours(23, 59, 59, 999);
  return d;
}

/** Lunes 00:00 de la semana que contiene ref */
export function startOfWeekMonday(ref) {
  const d = startOfDay(ref);
  const dow = d.getDay();
  d.setDate(d.getDate() + (dow === 0 ? -6 : 1 - dow));
  return d;
}

function fechaEnRango(d, desde, hasta) {
  const t = d.getTime();
  return t >= desde.getTime() && t <= hasta.getTime();
}

export const FECHA_FILTRO_VALORES = [
  "todos",
  "hoy",
  "esta_semana",
  "este_mes",
  "semana_pasada",
  "mes_pasado",
  "7d",
  "30d",
  "90d",
  "este_anio",
  "anio_pasado",
  "custom",
];

export function filtroFechaRangoMatch(filtro, d, hoy, fechaDesde, fechaHasta) {
  if (filtro === "todos") return true;
  if (!d || Number.isNaN(d.getTime())) return false;
  const hoy0 = startOfDay(hoy);
  if (filtro === "hoy") return fechaEnRango(d, hoy0, endOfDay(hoy));
  if (filtro === "7d") return d >= new Date(hoy0.getTime() - 7 * 86400000);
  if (filtro === "30d") return d >= new Date(hoy0.getTime() - 30 * 86400000);
  if (filtro === "90d") return d >= new Date(hoy0.getTime() - 90 * 86400000);
  if (filtro === "esta_semana") {
    return fechaEnRango(d, startOfWeekMonday(hoy), endOfDay(hoy));
  }
  if (filtro === "semana_pasada") {
    const inicioEsta = startOfWeekMonday(hoy);
    const inicio = new Date(inicioEsta);
    inicio.setDate(inicio.getDate() - 7);
    const fin = new Date(inicioEsta.getTime() - 1);
    return fechaEnRango(d, inicio, fin);
  }
  if (filtro === "este_mes") {
    return fechaEnRango(d, new Date(hoy.getFullYear(), hoy.getMonth(), 1), endOfDay(hoy));
  }
  if (filtro === "mes_pasado") {
    const inicio = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
    const fin = new Date(hoy.getFullYear(), hoy.getMonth(), 0, 23, 59, 59, 999);
    return fechaEnRango(d, inicio, fin);
  }
  if (filtro === "este_anio") {
    return fechaEnRango(d, new Date(hoy.getFullYear(), 0, 1), endOfDay(hoy));
  }
  if (filtro === "anio_pasado") {
    const inicio = new Date(hoy.getFullYear() - 1, 0, 1);
    const fin = new Date(hoy.getFullYear() - 1, 11, 31, 23, 59, 59, 999);
    return fechaEnRango(d, inicio, fin);
  }
  if (filtro === "custom") {
    if (fechaDesde && d < startOfDay(fechaDesde)) return false;
    if (fechaHasta && d > endOfDay(fechaHasta)) return false;
    return true;
  }
  return true;
}

/** Abre el calendario nativo del input date (Chrome/Edge). Ampliar: si falla, solo focus. */
export function abrirPickerFecha(el) {
  if (!el) return;
  try {
    if (typeof el.showPicker === "function") el.showPicker();
    else el.focus();
  } catch {
    try { el.focus(); } catch { /* ignore */ }
  }
}
